import { forwardRef, type InputHTMLAttributes } from 'react';

import { cx } from './cx';

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  mono?: boolean;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { mono, className, ...props },
  ref,
) {
  return <input ref={ref} className={cx('mf-input', mono && 'mono', className)} {...props} />;
});
